/** Display name for the Insights / Ask agent in Ops Command UI. */
export const INSIGHTS_AGENT_NAME = "maître d'AI";
